import Pagination from 'elements/pagination/Pagination'
import { styled } from 'opensolar-ui'
import MarketplaceDisclaimerBanner from 'pages/ordering/elements/MarketplaceDisclaimerBanner'

const Footer = styled('div')({
  marginTop: '16px',
})

type HardwareSelectorListPaginationFooterProps = {
  total: number
  page: number
  perPage: number
  setPage: (page: number) => void
  setPerPage: (perPage: number) => void
  source?: string
}

export const HardwareSelectorListPaginationFooter = ({
  total,
  page,
  perPage,
  setPage,
  setPerPage,
  source,
}: HardwareSelectorListPaginationFooterProps) => (
  <Footer>
    <MarketplaceDisclaimerBanner showBorder showIcon={false} showTitle={false} />
    <Pagination
      total={total}
      page={page}
      perPage={perPage}
      setPage={setPage}
      setPerPage={setPerPage}
      source={source}
    />
  </Footer>
)
